import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class DataService {
  API_URL = environment.apiURL;

  constructor(private http: HttpClient) {}

  get isLoggedIn() {
    return localStorage.getItem("cp_token") !== null;
  }

  logout() {
    localStorage.removeItem("cp_token");
  }

  get authHeader() {
    return new HttpHeaders({
      Authorization: "Bearer " + localStorage.getItem("cp_token"),
    });
  }

  checkAdmin() {
    return this.http.get<any>(this.API_URL + "checkadmin/", {
      headers: this.authHeader,
    });
  }

  getMessage() {
    return this.http.get<any>(this.API_URL + "message/", {
      headers: this.authHeader,
    });
  }

  getEvents() {
    return this.http.get<any>(this.API_URL + "event/", {
      headers: this.authHeader,
    });
  }

  addRecipient(formData: FormData) {
    return this.http.post<any>(this.API_URL + "add_participant/", formData, {
      headers: this.authHeader,
    });
  }

  addCustomTemplate(formData: FormData) {
    return this.http.post<any>(this.API_URL + "addCertificate/", formData, {
      headers: this.authHeader,
    });
  }

  getCertificate(event: string, year: string) {
    var url = environment.apiURL + "cert/";
    // var form = new FormData();
    // form.append("name", event);
    // form.append("year", year);
    return this.http.get<any>(url, { params: { name: event, year } });
  }

  performAction(action: string, id: string) {
    console.log(action, id);
    var body = { action, id };

    return this.http.post<any>(this.API_URL + "control/", body, {
      headers: this.authHeader,
    });
  }

  addNormalTemplate(formData: FormData) {
    return this.http.post<any>(
      this.API_URL + "addnormalCertificate/",
      formData,
      {
        headers: this.authHeader,
      }
    );
  }
}
